"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var search_styles_1 = require("./search.styles");
function Search(props) {
    var fieldAreaColor = props.disabled ? "#f4f6f7" : "#ffffff";
    var getSearchBoxClass = search_styles_1.getSearchBox(fieldAreaColor);
    var getSearchInputClass = search_styles_1.getSearchInput(fieldAreaColor);
    return (React.createElement("div", { className: search_styles_1.search, id: props.id + "-wrapper" },
        React.createElement("label", { className: "" + (props.searchTerm.length < 1 ? "searchIcon" : ""), id: "" + props.id, "data-qa": "multi-search" },
            React.createElement("span", { className: getSearchBoxClass },
                React.createElement("input", { className: getSearchInputClass, placeholder: props.placeholder, value: props.searchTerm, id: props.id + "-search", type: "text", autoFocus: true, onChange: props.handleChange, disabled: props.disabled, "data-qa-disabled": props.disabled }),
                props.searchTerm.length > 0 ? (React.createElement("a", { className: "clearSearch", onClick: props.clearSearch }, "X")) : ("")))));
}
exports.Search = Search;
